<template>
    <div class="location-info">
      <div class="location-info__content">
        <div class="location-info__blur-backdrop"></div>
        <div class="location-info__text">
          <!-- Desktop view -->
          <div class="desktop-only">
            <div class="transition-wrapper">
              <transition name="fade" mode="out-in">
                <p :key="`city-${activeFolder.title}`" class="location-info__city">
                  {{ activeFolder.city }}
                </p>
              </transition>
            </div>
            <div class="transition-wrapper">
              <transition name="fade" mode="out-in">
                <h2 :key="`title-${activeFolder.title}`" class="location-info__title">
                  {{ activeFolder.title }}
                </h2>
              </transition>
            </div>
            <div class="transition-wrapper">
              <transition name="fade" mode="out-in">
                <p :key="`desc-${activeFolder.title}`" class="location-info__description">
                  {{ activeFolder.description }}
                </p>
              </transition>
            </div>
          </div>
          
          <!-- Mobile view -->
          <div class="mobile-only">
            <div class="transition-wrapper">
              <transition name="fade" mode="out-in">
                <h2 :key="`mobile-title-${activeFolder.title}`" class="location-info__title">
                  {{ activeFolder.city }}
                </h2>
              </transition>
            </div>
            <div class="transition-wrapper">
              <transition name="fade" mode="out-in">
                <p :key="`mobile-desc-${activeFolder.title}`" class="location-info__description">
                  {{ activeFolder.mobileDescription }}
                </p>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "WorldLocationInfo",
    props: {
      activeFolder: {
        type: Object,
        required: true
      }
    }
  }
  </script>
  
  <style scoped>
  .location-info {
    padding: 2.4rem;
    width: 100%;
  }
  
  .location-info__content {
    position: relative;
    padding: 1.6rem;
  }
  
  .location-info__blur-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-radius: 4px;
  }
  
  .location-info__text {
    position: relative;
    z-index: 1;
  }
  
  .transition-wrapper {
    position: relative;
    height: 21px; /* Set this to match your line height */
    margin: 0;
  }

  .transition-wrapper:first-child {
    margin-bottom: 16px;
  }
  
  .transition-wrapper:last-child {
    margin-bottom: 0;
    height: auto; /* Allow description to be multi-line */
  }
  
  .location-info__city,
  .location-info__title,
  .location-info__description {
    position: absolute;
    width: 100%;
    margin: 0;
    line-height: 1.3;
  }
  
  .location-info__description {
    position: relative; /* Allow description to flow normally */
  }
  
  .location-info__city {
    font-family: 'Untitled Sans', sans-serif;
    font-size: 18px;
    font-weight: bold;
    color: #dcdcdc;
    transition-delay: 0ms;
  }
  
  .location-info__title {
    font-family: 'Untitled Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #dcdcdc;
    transition-delay: 100ms;
    letter-spacing: -0.03em;
  }
  
  .location-info__description {
    font-family: 'Untitled Sans', sans-serif;
    font-size: 16px;
    color: #C0C0C0;
    transition-delay: 200ms;
    letter-spacing: -0.03em;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease;
  }
  
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(4px);
  }
  
  /* Staggered animations for each element */
  .location-info__city.fade-enter-active {
    transition-delay: 0ms;
  }
  
  .location-info__title.fade-enter-active {
    transition-delay: 100ms;
  }
  
  .location-info__description.fade-enter-active {
    transition-delay: 200ms;
  }
  
  .location-info__city.fade-leave-active {
    transition-delay: 0ms;
  }
  
  .location-info__title.fade-leave-active {
    transition-delay: 50ms;
  }
  
  .location-info__description.fade-leave-active {
    transition-delay: 100ms;
  }

  @media screen and (max-width: 775px) {
    .location-info {
        padding: 0;
    }

    .desktop-only {
        display: none;
    }

    .transition-wrapper:first-child {
        margin: 0;
    }
    .transition-wrapper {
        height: 24px;
    }
    }

    @media screen and (min-width: 776px) {
        .mobile-only {
            display: none;
        }
    }
</style>